import i18n from "@/i18n"

export type { FrameFormat, FrameFormatClasses } from "./frame-format-core"
export {
  DEFAULT_FRAME_FORMAT,
  FRAME_FORMATS,
  effectiveFrameFormat,
  formatsDiffer,
  frameFormatClasses,
  frameFormatRatio,
  frameFormatShort,
  isExplicitShotFrameOverride,
  normalizeFrameFormat,
  storyboardTileFooterHeightPx,
  STORYBOARD_TILE_FOOTER_HEIGHT_PX,
  STORYBOARD_TILE_FOOTER_WITH_PROMPT_HEIGHT_PX,
} from "./frame-format-core"

import { normalizeFrameFormat } from "./frame-format-core"

export function frameFormatLabel(input?: string | null): string {
  switch (normalizeFrameFormat(input)) {
    case "16:9":
      return i18n.t("common:frameFormat.horizontal")
    case "1:1":
      return i18n.t("common:frameFormat.square")
    case "21:9":
      return i18n.t("common:frameFormat.ultrawide")
    case "3:4":
      return i18n.t("common:frameFormat.portrait34")
    case "4:3":
      return i18n.t("common:frameFormat.landscape43")
    default:
      return i18n.t("common:frameFormat.vertical")
  }
}
